"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExtensionServiceOptions = getExtensionServiceOptions;
var _config = require("./config");
var _platform = require("./platform");
// eslint-disable-next-line @tencent/tdoc-standalone/no-use-uri-like-literal
var TOB_CDN_PREFIX = (_config.npmConfig === null || _config.npmConfig === void 0 ? void 0 : _config.npmConfig.DOCS_COMPONENT_URL) || 'https://res.wx.qq.com/d/docs_components';
function getExtensionServiceOptions() {
  if (_platform.isWeworkEnv) {
    return {
      metadataLoader: {
        componentCdnPrefix: TOB_CDN_PREFIX
      }
      // ark-extensions 1.1.6 以上版本支持传参，低版本忽略这个参数，目前为了不影响品类依赖版本不升级依赖版本
      // 此处用 any 是为了兼容低版本，等主包依赖升级后可以删掉这个断言
    };
  }
  // C端使用缺省的参数
  return undefined;
}